export enum MongoDBConnectionType {
    Single,
    Cluster
}
